import { render, staticRenderFns } from "./airForm.vue?vue&type=template&id=4c2a08f5&"
import script from "./airForm.vue?vue&type=script&lang=js&"
export * from "./airForm.vue?vue&type=script&lang=js&"
import style0 from "./airForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2a08f5')) {
      api.createRecord('4c2a08f5', component.options)
    } else {
      api.reload('4c2a08f5', component.options)
    }
    module.hot.accept("./airForm.vue?vue&type=template&id=4c2a08f5&", function () {
      api.rerender('4c2a08f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceAir/components/airForm.vue"
export default component.exports